import { get } from 'lodash';

import { AppState } from 'Interfaces/Interfaces';

const root = (state: AppState) => get(state, 'unlinkStudentModalState');

export const getOpen = (state: AppState) => get(root(state), 'open', false);
export const getStudentId = (state: AppState) => get(root(state), 'studentId', null);
